export function Loader() {
  return (
    <div role="status" className="absolute flex animate-pulse gap-2 px-5 py-2">
      <div className="mb-4 h-6 w-6 rounded-full bg-gray-5"></div>
      <div className="mb-4 h-[22px] w-[160px] rounded-full bg-gray-5"></div>
    </div>
  );
}
